<template>
  <section
    id="faq"
    class="co-bg-striped"
  >
    <div class="co-container-lg py-20">
      <h2 class="co-display-7 mb-[3.25rem] text-center tracking-[.15em]">
        FAQ
      </h2>
      <div class="flex flex-wrap">
        <div class="mb-10 basis-full md:basis-1/2">
          <div class="mx-0 flex items-baseline justify-start px-4">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                2コース教えることはできますか？
              </h3>
            </div>
          </div>
          <div class="mx-0 flex items-baseline justify-start px-4">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <p>
                大丈夫です。現状でも複数のコースをメンタリングされてる方がいらっしゃいます。
              </p>
            </div>
          </div>
        </div>
        <div class="mb-10 basis-full md:basis-1/2">
          <div class="mx-0 flex items-baseline justify-start px-4">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                海外からの応募はできますか？
              </h3>
            </div>
          </div>
          <div class="mx-0 flex items-baseline justify-start px-4">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <p>
                大丈夫です。オンラインであればどこからでもメンタリングを行えます。ただ、日本時間に合わせてご対応いただきますので、時差の調整をお願いすることになります。
              </p>
            </div>
          </div>
        </div>
        <div class="mb-10 basis-full md:basis-1/2">
          <div class="mx-0 flex items-baseline justify-start px-4">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                マンツーマンメンタリング、チャットサポート、課題レビューの中から1業務だけ選ぶことはできますか？
              </h3>
            </div>
          </div>
          <div class="mx-0 flex items-baseline justify-start px-4">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <p>
                基本的には当社の方で業務の振り分けをさせて頂きたいと考えておりますが、ご要望頂けましたらそのようなご対応も可能となります。
              </p>
            </div>
          </div>
        </div>
        <div class="mb-10 basis-full md:basis-1/2">
          <div class="mx-0 flex items-baseline justify-start px-4">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                プログラミングを教えた経験がないのですが、大丈夫でしょうか？
              </h3>
            </div>
          </div>
          <div class="mx-0 flex items-baseline justify-start px-4">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <p>
                大丈夫です。当社の方でサポート体制も整えておりますので、ご安心ください。
              </p>
            </div>
          </div>
        </div>
        <div class="mb-10 basis-full md:mb-0 md:basis-1/2">
          <div class="mx-0 flex items-baseline justify-start px-4">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                所有PCがWindowsなのですが問題ないでしょうか？
              </h3>
            </div>
          </div>
          <div class="mx-0 flex items-baseline justify-start px-4">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <p>
                問題ございません。当社からはMacを推奨しておりますが、Windowsでメンタリングされている方もいらっしゃいます。
              </p>
            </div>
          </div>
        </div>
        <div class="basis-full md:basis-1/2">
          <div class="mx-0 flex items-baseline justify-start px-4">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                マニュアルや研修などはありますでしょうか？
              </h3>
            </div>
          </div>
          <div class="mx-0 flex items-baseline justify-start px-4">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <p>
                マニュアルとオリエンテーションをご用意しておりますので、そちらをご確認いただくことになります。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
